import compact from "lodash/compact";
import { Filter } from "PFTypes";

export const createDropdownId = (filter: Filter) =>
  compact([filter.children ? "children" : null, filter.name]).join("-");
